export default "__VITE_ASSET__DyOyo1du__"